import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  fetchEventsTillArgsConfig,
  fetchOnlyFutureEventsArgsConfig,
  getItemIdFromArgsConfig,
  googleCalendarCollectionArgsConfig,
  redirectUrlArgsConfig,
  retainUrlParamsArgsConfig,
  sendMeetingNotificationsArgsConfig,
} from '../../utils/event_constants';

export const googleActions = [
  {
    name: 'initiateGoogleCalendarAuth',
    label: 'Initiate Google Calendar Auth',
    args: [...redirectUrlArgsConfig, retainUrlParamsArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'fetchGoogleCalendarEvents',
    label: 'Fetch Google Calendar Events',
    args: [
      googleCalendarCollectionArgsConfig,
      collectionFieldArgsConfig({ name: 'userIdentifierField', label: 'User Identifier Field' }),
      fetchEventsTillArgsConfig,
      fetchOnlyFutureEventsArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'syncGoogleCalendarEvents',
    label: 'Sync Google Calendar Events',
    args: [
      googleCalendarCollectionArgsConfig,
      collectionFieldArgsConfig({ name: 'userIdentifierField', label: 'User Identifier Field' }),
      collectionFieldArgsConfig({ name: 'eventIdField', label: 'Google Calendar Event ID Field' }),
      fetchEventsTillArgsConfig,
      fetchOnlyFutureEventsArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'scheduleGoogleCalendarEvent',
    label: 'Schedule a Google Calendar Event',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'summaryField', label: 'Select Meeting Title Field' }),
      collectionFieldArgsConfig({ name: 'descriptionField', label: 'Meeting Description Field' }),
      collectionFieldArgsConfig({ name: 'hostField', label: 'Select Host UUID Field' }),
      {
        name: 'loggedInUserAsHost',
        label: 'Logged in user as Host',
        type: 'boolean',
        value: '',
      },
      collectionFieldArgsConfig({ name: 'attendeesField', label: 'Select Attendees Field' }),
      collectionFieldArgsConfig({ name: 'userIdentifierField', label: 'User Identifier Field' }),
      collectionFieldArgsConfig({ name: 'startTimeField', label: 'Start Time Field' }),
      collectionFieldArgsConfig({
        name: 'durationField',
        label: 'Select Event Duration Field (in minutes)',
      }),
      {
        name: 'conferenceProvider',
        label: 'Select Video Conference Provider',
        type: 'dropdown',
        options: [],
        optionsType: 'conferenceProviderApi',
        value: '',
      },
      {
        name: 'checkAvailablity',
        label: 'Check attendees availablity',
        type: 'boolean',
        value: '',
      },
      sendMeetingNotificationsArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'updateGoogleCalendarEvent',
    label: 'Update a Google Calendar Event',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'eventIdField', label: 'Google Calendar Event ID Field' }),
      collectionFieldArgsConfig({ name: 'summaryField', label: 'Select Meeting Title Field' }),
      collectionFieldArgsConfig({ name: 'descriptionField', label: 'Meeting Description Field' }),
      collectionFieldArgsConfig({ name: 'attendeesField', label: 'Select Attendees Field' }),
      collectionFieldArgsConfig({ name: 'startTimeField', label: 'Start Time Field' }),
      collectionFieldArgsConfig({
        name: 'durationField',
        label: 'Select Event Duration Field (in minutes)',
      }),
      {
        name: 'checkAvailablity',
        label: 'Check attendees availablity',
        type: 'boolean',
        value: '',
      },
      sendMeetingNotificationsArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'deleteGoogleCalendarEvent',
    label: 'Delete a Google Calendar Event',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'eventIdField', label: 'Google Calendar Event ID Field' }),
      sendMeetingNotificationsArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'initiateGoogleMeetAuth',
    label: 'Initiate Google Meet Auth',
    args: [...redirectUrlArgsConfig, retainUrlParamsArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'createInstantGoogleMeet',
    label: 'Create an Instant Google Meet',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'summaryField', label: 'Select Meeting Title Field' }),
      collectionFieldArgsConfig({ name: 'descriptionField', label: 'Meeting Description Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({
        name: 'durationField',
        label: 'Select Event Duration Field (in minutes)',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
];
